module.exports = __webpack_public_path__ + "static/media/logo-home.4ee536a3.svg";